export const FIELD_MAPPING_CONSTANTS = {
  MIN_MAPPINGS_REQUIRED: 1,
  ROUTES: {
    CHOOSE_SYNC: "/dashboard/choose-sync",
    SYNC_DIRECTION: "/dashboard/sync-direction",
    CONNECTORS: "/dashboard/connectors",
  },
  STORAGE_KEYS: {
    FIELD_MAPPINGS: "fieldMappings",
    HUBSPOT_TENANT_ID: "hubspot_tenant_id",
    CONNECTOR_FLOW_STEP: "connectorFlowStep",
    HUBSPOT_CONNECTED: "hubspot_connected",
    SALESFORCE_CONNECTED: "salesforce_connected",
    SALESFORCE_TENANT_ID: "salesforce_tenant_id",
  },
  ERROR_MESSAGES: {
    NO_TENANT_ID: "Tenant ID not found. Please log in again.",
    NO_CONNECTOR_ID: "Connector ID not found. Please select a connector.",
    INVALID_FIELD_DATA: "Invalid field data received from server",
    NO_MAPPINGS: "Please add at least one field mapping before continuing.",
    INCOMPLETE_MAPPINGS: "Please ensure all field mappings have both HubSpot and Salesforce fields selected.",
    HUBSPOT_FIRST: "Please connect HubSpot first",
    NO_HUBSPOT_TENANT: "HubSpot tenant ID not found. Please reconnect HubSpot.",
  },
} as const
